import { TextAreaInput } from "@jugl-web/ui-components/cross-platform/forms/TextAreaInput";
import { useTranslations } from "@jugl-web/utils";

import { useInvoicesSettingsPageContext } from "@web-src/modules/invoices/pages/InvoicesSettingsPage/context/useInvoicesSettingsPageContext";

export const NotesField = () => {
  const { t } = useTranslations();
  const { register, formValues } = useInvoicesSettingsPageContext();

  return (
    <>
      <h2 className="mt-0 mb-8 font-secondary text-base font-medium">
        {t({
          id: "invoices.settings.businessInformation.notes",
          defaultMessage: "Additional notes",
        })}
      </h2>

      <div className="relative w-full">
        <TextAreaInput
          label={t({
            id: "invoices.settings.businessInformation.notes",
            defaultMessage: "Additional notes",
          })}
          {...register("note", {
            maxLength: {
              value: 1000,
              message: "Additional notes cannot exceed 1000 characters",
            },
          })}
          maxLength={1000}
          lengthIndicator={{
            max: 1000,
          }}
          isInvalid={Boolean(
            formValues.note && formValues.note?.length >= 1000
          )}
          classNames={{
            inputWrapperClassName: "h-32 w-full",
            inputClassName:
              "min-h-full max-h-full jugl__custom-scrollbar overflow-y-auto",
          }}
        />
      </div>
    </>
  );
};
